import { memo } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { paths } from '@/shared/config/paths';
import { useAuthStore } from '@/store/useAuthStore';

const AuthGuard = () => {
	const { isAuthenticated } = useAuthStore();

	if (!isAuthenticated) {
		return <Navigate to={paths.login} replace />;
	}

	return <Outlet />;
};

export default memo(AuthGuard);
